import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { defaultTableSelection } from './pm-plugins/default-table-selection';
export default (function (pluginState, action) {
  switch (action.type) {
    case 'TOGGLE_HEADER_COLUMN':
      return _objectSpread(_objectSpread({}, pluginState), {}, {
        isHeaderColumnEnabled: !pluginState.isHeaderColumnEnabled
      });
    case 'TOGGLE_HEADER_ROW':
      return _objectSpread(_objectSpread({}, pluginState), {}, {
        isHeaderRowEnabled: !pluginState.isHeaderRowEnabled
      });
    case 'CLEAR_HOVER_SELECTION':
      return _objectSpread(_objectSpread(_objectSpread({}, pluginState), action.data), defaultTableSelection);
    case 'SELECT_COLUMN':
      return _objectSpread(_objectSpread(_objectSpread({}, pluginState), action.data), {}, {
        isContextualMenuOpen: false
      });
    case 'SET_TARGET_CELL_POSITION':
      return _objectSpread(_objectSpread(_objectSpread({}, pluginState), action.data), {}, {
        isContextualMenuOpen: false
      });
    case 'SET_TABLE_LAYOUT':
      return _objectSpread(_objectSpread({}, pluginState), action.data);
    case 'TOGGLE_CONTEXTUAL_MENU':
      return _objectSpread(_objectSpread({}, pluginState), {}, {
        isContextualMenuOpen: !pluginState.isContextualMenuOpen
      });
    case 'SHOW_INSERT_ROW_BUTTON':
      if (action.data.insertRowButtonIndex === pluginState.insertRowButtonIndex) {
        return pluginState;
      }
      return _objectSpread(_objectSpread(_objectSpread({}, pluginState), action.data), {}, {
        insertColumnButtonIndex: undefined // We need to assure that column is not shown
      });

    case 'SHOW_INSERT_COLUMN_BUTTON':
      if (action.data.insertColumnButtonIndex === pluginState.insertColumnButtonIndex) {
        return pluginState;
      }
      return _objectSpread(_objectSpread(_objectSpread({}, pluginState), action.data), {}, {
        insertRowButtonIndex: undefined // We need to assure that row is not shown
      });

    case 'HIDE_INSERT_COLUMN_OR_ROW_BUTTON':
      if (pluginState.insertRowButtonIndex !== undefined || pluginState.insertColumnButtonIndex !== undefined) {
        return _objectSpread(_objectSpread({}, pluginState), {}, {
          insertRowButtonIndex: undefined,
          insertColumnButtonIndex: undefined
        });
      }
      return pluginState;
    case 'HIDE_RESIZE_HANDLE_LINE':
      return _objectSpread(_objectSpread(_objectSpread({}, pluginState), action.data), {}, {
        resizeHandleColumnIndex: undefined,
        resizeHandleRowIndex: undefined
      });
    case 'ADD_RESIZE_HANDLE_DECORATIONS':
      if (action.data.resizeHandleColumnIndex === pluginState.resizeHandleColumnIndex && action.data.resizeHandleRowIndex === pluginState.resizeHandleRowIndex) {
        return pluginState;
      }
      return _objectSpread(_objectSpread({}, pluginState), action.data);
    case 'SET_TABLE_REF':
    case 'HOVER_ROWS':
    case 'HOVER_COLUMNS':
    case 'HOVER_TABLE':
    case 'HOVER_CELLS':
    case 'SHOW_RESIZE_HANDLE_LINE':
    case 'SET_EDITOR_FOCUS':
      return _objectSpread(_objectSpread({}, pluginState), action.data);
    default:
      return pluginState;
  }
});